// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavBar_nav__1FWUI","search":"NavBar_search__3wOLb","pHP":"NavBar_pHP__3g3I4","pCP":"NavBar_pCP__3R9sR","link":"NavBar_link__2Iixg"};